import React, { useState } from 'react';
    import { Link, useLocation } from 'react-router-dom';
    import { motion } from 'framer-motion';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiMenu, FiX } = FiIcons;

    const Header = () => {
      const [isMenuOpen, setIsMenuOpen] = useState(false);
      const location = useLocation();

      const navigation = [
        { name: 'Home', href: '/' },
        { name: 'About', href: '/about' },
        { name: 'Services', href: '/services' },
        { name: 'Courses', href: 'https://resources.divorcewithdirection.co.uk', isExternal: true }
      ];

      const isActive = (href) => {
        if (href === '/' && location.pathname === '/') return true;
        if (href !== '/' && !href.startsWith('http') && location.pathname.startsWith(href)) return true;
        return false;
      };

      const NavLink = ({ item, mobile = false }) => {
        const className = mobile
          ? `text-base font-inter font-medium transition-colors duration-200 ${isActive(item.href) ? 'text-sage-500' : 'text-gray-600 hover:text-sage-500'}`
          : `text-sm font-inter font-medium transition-all duration-200 hover:text-sage-500 ${isActive(item.href) ? 'text-sage-500' : 'text-gray-600'}`;

        if (item.isExternal) {
          return (
            <a 
              href={item.href} 
              target="_blank" 
              rel="noopener noreferrer" 
              className={className}
              onClick={() => mobile && setIsMenuOpen(false)}
            >
              {item.name}
            </a>
          );
        }

        return (
          <Link 
            to={item.href} 
            className={className}
            onClick={() => mobile && setIsMenuOpen(false)}
          >
            {item.name}
          </Link>
        );
      };

      return (
        <header className="bg-white/95 backdrop-blur-sm border-b border-gray-100 sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex justify-between items-center py-4">
              {/* Desktop Left Nav */}
              <nav className="hidden lg:flex items-center space-x-6 flex-1 justify-end pr-8">
                {navigation.map((item) => (
                  <NavLink key={item.name} item={item} />
                ))}
              </nav>

              {/* Logo */}
              <Link to="/" className="flex-shrink-0">
                <div className="text-center leading-tight">
                  <div style={{ color: 'rgb(17, 24, 39)', fontSize: '40px' }} className="text-lg md:text-xl lg:text-2xl font-canela font-medium tracking-tight">
                    Divorce
                  </div>
                  <div className="text-lg md:text-xl lg:text-2xl font-canela font-medium tracking-tight">
                    with Direction
                  </div>
                </div>
              </Link>

              {/* Desktop CTA */}
              <nav className="hidden lg:flex items-center flex-1 pl-8">
                <a 
                  href="https://tidycal.com/dwd/discovery-call" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="bg-sage-500 text-white px-6 py-2.5 rounded-full text-sm font-inter font-medium hover:bg-sage-600 transition-all duration-200 shadow-sm hover:shadow-md"
                >
                  Schedule Free Discovery Call
                </a>
              </nav>

              {/* Mobile Menu Button */}
              <div className="lg:hidden">
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 hover:text-sage-500 transition-colors p-2">
                  <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="h-5 w-5" />
                </button>
              </div>
            </div>

            {/* Mobile Navigation */}
            {isMenuOpen && (
              <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="lg:hidden border-t border-gray-100 py-4">
                <nav className="flex flex-col space-y-4">
                  {navigation.map((item) => (
                    <NavLink key={item.name} item={item} mobile />
                  ))}
                  <a 
                    href="https://tidycal.com/dwd/discovery-call" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    onClick={() => setIsMenuOpen(false)} 
                    className="bg-sage-500 text-white px-6 py-2.5 rounded-full text-sm font-inter font-medium hover:bg-sage-600 transition-all duration-200 text-center"
                  >
                    Schedule Free Discovery Call
                  </a>
                </nav>
              </motion.div>
            )}
          </div>
        </header>
      );
    };

    export default Header;